import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import CssBaseline from '@mui/material/CssBaseline';
import BrandThemeProvider from './theme/BrandThemeProvider';
import App from "./App";
import AppSimple from "./AppSimple";
import AppTest from "./AppTest";

// Theme is now fully dynamic and built from saved branding settings

// Import du composant IA
import AppWithAI from './components/AppWithAI';

// Sélection de l'application selon la variable d'environnement
const entryPoint = process.env.REACT_APP_ENTRY;
let AppComponent;

if (entryPoint === 'ai') {
  AppComponent = AppWithAI;
} else if (entryPoint === 'simple') {
  AppComponent = AppSimple;
} else if (entryPoint === 'test') {
  AppComponent = AppTest;
} else {
  // Par défaut, utiliser l'application principale avec la nouvelle page d'accueil
  AppComponent = App;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrandThemeProvider>
      <CssBaseline />
      <BrowserRouter>
        <AppComponent />
      </BrowserRouter>
    </BrandThemeProvider>
  </React.StrictMode>
);

// Enregistrement du Service Worker pour PWA
// Active l'installation sur mobile et le fonctionnement hors-ligne